export function getCourseSlug(pathname: string): string {
  const pathParts = pathname.split('/');

  // В mindbox записаны слаги курсов без слэшек по краям
  return pathParts[2];
}
